module.exports = "/images/make-an-ofer.png?f262be29a4c617ac7df3b4f1a6bbe56d";